import EcoTextTc from 'eco-design/sections/eco-text-tc';
import React from 'react';
import css from './index.module.scss';
import { useLang } from '@/i18n';

const TC: React.FC = () => {
    const { t } = useLang('TC');

    const items = [
        { title: '' },
        ...new Array(12).fill(null).map((item, index) => ({
            title: t(`title${index}`),
        })),
    ];

    return (
        <div className="GtmModuleData-section" data-section-id="d3c-FooterTcA">
            <EcoTextTc className={css.comp} items={items} />
        </div>
    );
};
export default TC;
